module.exports = __webpack_public_path__ + "img/my_customer.d997ae02.png";